import type { SVGProps } from 'react';
const SvgNetworkCell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#network_cell_svg__a)">
      <path fill="currentColor" d="M2 22h20V2L2 22Zm18-2h-3V9.83l3-3V20Z" />
    </g>
    <defs>
      <clipPath id="network_cell_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNetworkCell;
